import React from "react";
import { Modal, Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    textAlign: "center",
  },
}));

const ShowcaseModal = ({ open, handleClose }) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="showcase-modal-title"
      aria-describedby="showcase-modal-description"
    >
      <Box className={classes.modalBox}>
        <Typography
          id="showcase-modal-title"
          variant="h6"
          component="h2"
          gutterBottom
        >
          Fonctionnalité Premium
        </Typography>
        <Box sx={{ mt: 2, mb: 2, textAlign: "center" }}>
          <img
            src="/assets/animation-premium-custom-session.gif"
            alt="Premium feature animation"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Box>
        <Typography id="showcase-modal-description" sx={{ mt: 2 }} gutterBottom>
          La génération de sessions personnalisées est une fonctionnalité
          premium. Connectez-vous ou inscrivez-vous pour essayer une session de
          démonstration, ou passez à premium pour un accès illimité !
        </Typography>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          style={{ marginTop: "16px" }}
        >
          Fermer
        </Button>
        {/* Optional: Add Login/Signup or Premium buttons here */}
      </Box>
    </Modal>
  );
};

export default ShowcaseModal;
